import { Fade, Box, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import muiTheme from '../theme/muiTheme.js'; // Adjust path based on your project structure

export default function ErrorDisplay({ message, type = 'error', clearMessage }) {
  if (!message) return null;

  const isError = type === 'error';
  const backgroundColor = isError ? '#ffebee' : '#e8f5e9';
  const borderColor = isError ? muiTheme.palette.error.main : muiTheme.palette.success.main;
  const iconColor = isError ? muiTheme.palette.error.main : muiTheme.palette.success.main;

  return (
    <Fade in={true} timeout={300}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor,
          border: `1px solid ${borderColor}`,
          borderRadius: '8px',
          padding: '10px',
          marginBottom: '10px',
          color: '#333',
        }}
        aria-live="assertive"
      >
        <span style={{ flex: 1 }}>{message}</span>
        <IconButton
          size="small"
          aria-label="Clear message"
          onClick={clearMessage}
          sx={{ color: iconColor }}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      </Box>
    </Fade>
  );
}